export default "__VITE_ASSET__PWDnhBDf__"